module.exports = __webpack_public_path__ + "img/empty-folder.21e10bcb.svg";